import { useQuery, useMutation } from '@tanstack/react-query';
import { type Result } from '@synqo/frontend-component-library';
import { usePermissionsRepository } from '@Hooks/useRepository';
import { ImportUserRepository } from '@Repositories/Permissions';
import type { ApiUser } from '@Model';

export function useImportSourceUsers(enabled: boolean) {
    const importUsers = usePermissionsRepository(ImportUserRepository);

    const { data, isLoading } = useQuery<Result<ApiUser[]>, unknown, Result<ApiUser[]>>({
        queryKey: ['permissions', 'user-import', 'users'],
        queryFn: () => importUsers.getImportableUsers(),
        enabled,
    });

    return {
        isLoading,
        users: data?.data ?? [],
        messages: data?.messages ?? [],
    };
}

export function useImportUser() {
    const importUsers = usePermissionsRepository(ImportUserRepository);

    return useMutation({
        mutationFn: (sourceUserId: string) => importUsers.importUser(sourceUserId),
    });
}
